export default __webpack_public_path__ + "static/media/banco-falabella.fdd33e25.svg";